import { gql } from "@apollo/client"

export const MiniCompanyProfileFragment = gql`
    fragment MiniCompanyProfile_company on CompanyType {
        id
        slug
        imageFile(retrieveSize: false) {
            source
        }
        name
        tagline
        size {
            id
            name
        }
        yearFounded
        totalRaised
        fundingLevel {
            id
            intuitiveName
        }
        officePreference
        cities {
            edges {
                node {
                    id
                    shortLabel
                }
            }
        }
    }
`
